import { scrollTracker } from "./utilities/scrollTracker"
import { masthead } from "./blocks/masthead"
import { people } from "./blocks/people"
import { portfolio } from "./blocks/portfolio"
import { focusSlider } from "./blocks/focusSlider"
import { choicesJS } from "./utilities/choices"
import { alignFull } from "./utilities/alignFull"
import { inview } from "./utilities/inview"
import { navigation } from "./utilities/navigation"
import { lottieAnimations } from "./utilities/lottieAnimations"
import { wpBlockButtons } from "./blocks/wp-block-buttons"

document.addEventListener("DOMContentLoaded", () => {
  scrollTracker();
  masthead();
  people();
  portfolio();
  focusSlider();
  choicesJS();
  alignFull();
  inview();
  navigation();
  lottieAnimations();
  wpBlockButtons();
});


